export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Menu</title>
    <path
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeWidth="1.5"
      d="M4 10.25h24M4 21.25h24"
    />
  </svg>
);
